import type { ReactiveController, ReactiveControllerHost } from "lit";

export class MediaController implements ReactiveController {
  private prevObjectUrl?: string;

  constructor(host: ReactiveControllerHost) {
    host.addController(this);
  }

  hostConnected(): void {}

  hostDisconnected(): void {
    this.revokePrevObjectUrl();
  }

  stopGlobalAudio(sourceId: string): void {
    try {
      window.dispatchEvent(
        new CustomEvent("hollo-stop-audio", { detail: { id: sourceId } })
      );
    } catch {}
  }

  stopLiveCard(shadowRoot: ShadowRoot | null | undefined): void {
    try {
      const live = shadowRoot?.querySelector("hollo-live-card") as unknown as {
        stopCurrentVideo?: () => void;
        playCurrentVideo?: () => void;
      } | null;
      if (live && typeof live.stopCurrentVideo === "function") {
        live.stopCurrentVideo();
      }
    } catch {}
  }

  playLiveVideo(shadowRoot: ShadowRoot | null | undefined): void {
    try {
      const live = shadowRoot?.querySelector("hollo-live-card") as unknown as {
        playCurrentVideo?: () => void;
      } | null;
      if (live && typeof live.playCurrentVideo === "function") {
        live.playCurrentVideo();
      }
    } catch {}
  }

  setPrevObjectUrl(url?: string): void {
    if (this.prevObjectUrl && this.prevObjectUrl !== url) {
      this.revokePrevObjectUrl();
    }
    if (url && url.startsWith("blob:")) this.prevObjectUrl = url;
  }

  revokePrevObjectUrl(): void {
    if (this.prevObjectUrl) {
      try {
        URL.revokeObjectURL(this.prevObjectUrl);
      } catch {}
    }
    this.prevObjectUrl = undefined;
  }
}
